import { BehaviorSubjectToObservable } from '../BehaviorSubjectToObservable';

export const [rxAddresses, nextAddresses] = BehaviorSubjectToObservable([]);

